import type { AbilityLevelRequirementGateInput } from '../types';

/** Decide whether one normalized ability row survives the authoritative player-only level gate. */
export function meetsAbilityLevelRequirements(input: AbilityLevelRequirementGateInput): boolean {
    if (!input.isPlayerCharacter) return true;
    // Status / aura PAYLOAD (PHP twin: ft_ability_entry_is_status_delivered): gated on the aura's owner, never the holder.
    if (input.statusDelivered === true) return true;
    if (input.requiresLevel !== null && input.requiresLevel > input.totalLevel) return false;

    if (input.requiresClassLevel !== null) {
        const classLevel = input.sourceClassLevel ?? input.totalLevel;
        if (input.requiresClassLevel > classLevel) return false;
    }
    return true;
}
